export function insertPropertiesInFeatures(driverFeatures: Array<Object>, driverProperties: Array<Object>): Object {
    
    const featureDict: Object = {};

    driverFeatures.forEach(driverFeature => {
        driverFeature.properties = [];
        featureDict[driverFeature.name] = driverFeature;
    });

    driverProperties.forEach(property => {
        const feature: Object = featureDict[property.info.name.split('.')[0]];
        if (feature) {
            feature.properties.push(property);
        }
    });

    return featureDict;
}

export function getPropertiesFromFeature(driverFeature: Object, driverProperties: Array<Object>): Object {
    
    const properties = {};

    for (let i = 0; i < driverFeature.instanceCount; i++) {
        properties[`ch_${i}`] = {};
    }

    driverProperties.forEach(property => {

        /*** START FIX ***/
        // if (property.info.name === 'tf.min' && property.value === 'Off') {
        //     property.value = property.valueMeta.default;
        // }
        /*** END FIX ***/


        /*** START CORRIDOR ***/
        {
            const indexOfUnderscore = driverFeature.name.indexOf("_");
            const name = indexOfUnderscore >= 0 ? driverFeature.name.substring(0, indexOfUnderscore) : driverFeature.name;
            if (property.info.name.split('.')[0] !== name) {
                return;
            }
        }
        /*** END CORRIDOR ***/

        /*** START SPLIT CHANNEL ***/
        const indexOfUnderscore = property.info.name.indexOf("_");
        if (indexOfUnderscore === -1) {
            properties["ch_0"][property.info.name] = property;
        } else {
            const indexOfChannel = property.info.name.substring(indexOfUnderscore + 1, property.info.name.length);
            if (properties[`ch_${indexOfChannel}`] === undefined) {
                return;
            }
            properties[`ch_${indexOfChannel}`][property.info.name.substring(0, indexOfUnderscore)] = property;
        }
        // if (driverFeature.instanceCount > 0 /*TODO WAS 1 */) {

        //     const indexOfUnderscore = property.info.name.indexOf("_");
        //     const indexOfChannel = property.info.name.substring(indexOfUnderscore + 1, property.info.name.length);

        //     properties[`ch_${indexOfChannel}`][property.info.name.substring(0, indexOfUnderscore)] = property;
        // } else {
        //     properties["ch_0"][property.info.name] = property;
        // }
        /*** END SPLIT CHANNEL ***/
    });

    return properties;
}